import React from 'react';
import '../App.css';
import { PacmanLoader } from 'react-spinners';


const Loader = () => {
    return (
        <div className="loading-screen">
            <PacmanLoader color="#576FA8" height={15} width={5} />
        </div>
    );
}

export default Loader;